var _defs, _path, _polygon, _polygon2, _polygon3, _path2, _polygon4, _path3, _path4, _polygon5, _path5, _polyline, _polygon6, _polyline2, _polygon7, _polygon8, _polyline3, _polygon9, _polygon10, _polygon11, _ellipse, _ellipse2, _line, _polygon12, _ellipse3, _ellipse4, _line2, _polygon13, _ellipse5, _ellipse6, _line3, _polyline4, _polyline5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataArrangingIsometric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 300",
    "data-imageid": "data-arranging-isometric",
    imageName: "Data Arranging",
    className: "illustrations_image",
    style: {
      width: 237
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 153.61,
    y1: 235.61,
    x2: 136.22,
    y2: 206.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#009471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 286.32,
    y1: 237.02,
    x2: 265.23,
    y2: 210.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 252.6,
    y1: 185.8,
    x2: 235.22,
    y2: 156.67,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "151-160") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.62,77.46,27.18,162.65a9.33,9.33,0,0,0,.14,16.21L206.57,279.17a14.76,14.76,0,0,0,14.2.12l137.73-74.07a11.23,11.23,0,0,0,.34-19.58Z",
    fill: "#3cc7ce"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.39,208c-21.07-12-50.17-13.66-60.5-20.12L86.45,200.57c9.46,5,18.32,11.71,27.1,16.74q12.7,7.27,25.2,14.88C152.9,222.84,168.71,216.43,183.39,208Z",
    opacity: 0.31,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.92,231.43c17.05,9.76,33.79,20,50.44,30.48,13.73-6.67,93.56-43.9,110.15-56.07-23.87-12.44-67.84-44.82-82.58-54l-105.11,62.9C180.28,219.65,189.14,226.4,197.92,231.43Z",
    opacity: 0.63,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "126.2 191.09 207.27 236.95 301.94 181.82 301.94 144.75 207.27 199.88 126.2 153.55 126.2 191.09",
    fill: "#a0d700"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "126.2 153.55 222.68 98.19 301.94 144.75 207.27 199.88 126.2 153.55",
    fill: "#cbed4f"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "207.27 199.88 207.27 236.95 301.94 181.82 301.94 144.75 207.27 199.88",
    fill: "#93bc00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209,217.17,217.46,248a2.52,2.52,0,0,0,3.36,1.49L264,223.65a1.42,1.42,0,0,0,.64-1.58l-7.52-32.7a2.4,2.4,0,0,0-3.42-1.41l-43.86,27.09A1.82,1.82,0,0,0,209,217.17Z",
    fill: "#68e1fd",
    className: "target-color"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.01 216.54 224.27 243.8 260.29 222.18 253.7 193.92 217.01 216.54",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.27,243.8l4.86-19.25c.51-2,2.94-2.94,5.43-2.11l5.36,1.8L246,209.79c.61-1.45,2.66-1.89,4.38-1l7.81,4.29,2.11,9Z",
    fill: "#8ccc00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.77,208.79l8.42,30.81a2.52,2.52,0,0,0,3.36,1.49l43.21-25.83a1.42,1.42,0,0,0,.64-1.58L270.88,181a2.4,2.4,0,0,0-3.42-1.41L223.6,206.67A1.82,1.82,0,0,0,222.77,208.79Z",
    fill: "#68e1fd",
    className: "target-color"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "230.73 208.15 237.99 235.41 274.01 213.8 267.42 185.53 230.73 208.15",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M238,235.41l4.86-19.25c.51-2,2.94-2.94,5.43-2.11l5.36,1.8,6.07-14.44c.61-1.45,2.66-1.89,4.38-1l7.81,4.29,2.11,9Z",
    fill: "#8ccc00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282.39,158.22c-21.07-12-44.11-25.82-54.44-32.28l-42.5,24.82c9.46,5,18.32,11.71,27.1,16.74q12.7,7.27,25.2,14.88C251.9,173,267.71,166.62,282.39,158.22Z",
    opacity: 0.31,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "122.25 78.72 122.25 115.74 203.47 161.96 239.38 141.23 239.38 103.74",
    fill: "#68e1fd",
    className: "target-color"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.64 125.44 202.64 161.96 239.38 141.23 239.38 103.74 202.64 125.44",
    fill: "#68e1fd",
    className: "target-color"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "122.25 78.72 122.25 115.74 203.47 161.96 239.38 141.23 239.38 103.74",
    opacity: 0.15
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.64 125.44 239.38 103.74 159.25 57.69 122.25 78.72 202.64 125.44",
    fill: "#68e1fd",
    className: "target-color"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.64 125.44 202.64 161.96 239.38 141.23 239.38 103.74 202.64 125.44",
    opacity: 0.15
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "289.76 103.59 289.76 147.06 256.09 166.5 228.66 150.2 228.66 109.8",
    fill: "#3aceb2"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.09 166.5 256.09 123.61 228.66 107.54 228.66 150.2 256.09 166.5",
    fill: "#4be2c5"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "262.04 87.16 289.76 103.59 256.09 123.61 228.66 107.54 262.04 87.16",
    fill: "#52efd1"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "285.37 110.74 285.37 119.74 260.14 134.13 260.14 125.3 285.37 110.74",
    fill: "#7374b7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 263,
    cy: 128.22,
    rx: 1.07,
    ry: 0.67,
    transform: "matrix(0.29, -0.96, 0.96, 0.29, 63.25, 342.03)",
    fill: "#f7931e"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.15,
    cy: 126.96,
    rx: 1.07,
    ry: 0.67,
    transform: "translate(65.98 343.19) rotate(-72.94)",
    fill: "#d9e021"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 267.53,
    y1: 125.97,
    x2: 283.13,
    y2: 117.02,
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "285.96 123.35 285.96 132.35 260.73 146.74 260.73 137.92 285.96 123.35",
    fill: "#7374b7"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.6,
    cy: 140.84,
    rx: 1.07,
    ry: 0.67,
    transform: "translate(51.61 351.51) rotate(-72.94)",
    fill: "#f7931e"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.75,
    cy: 139.57,
    rx: 1.07,
    ry: 0.67,
    transform: "translate(54.34 352.67) rotate(-72.94)",
    fill: "#d9e021"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 268.13,
    y1: 138.58,
    x2: 283.72,
    y2: 129.63,
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "285.96 135.94 285.96 144.94 260.73 159.34 260.73 150.51 285.96 135.94",
    fill: "#7374b7"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.6,
    cy: 153.43,
    rx: 1.07,
    ry: 0.67,
    transform: "translate(39.57 360.41) rotate(-72.94)",
    fill: "#f7931e"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.75,
    cy: 152.17,
    rx: 1.07,
    ry: 0.67,
    transform: "translate(42.3 361.57) rotate(-72.94)",
    fill: "#d9e021"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 268.13,
    y1: 151.18,
    x2: 283.72,
    y2: 142.22,
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "228.66 122.48 255.96 138.58 289.76 118.95",
    fill: "none",
    stroke: "#1b1464",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "228.66 135.07 255.96 151.18 289.76 131.55",
    fill: "none",
    stroke: "#1b1464",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M291.62,109.26s-3,13.28-3.56,14.83-5.31,9.32-5.31,9.32-4.44,2.41-3.44,3a2.67,2.67,0,0,0,2.16,0s-1.29,5-.65,6.17,3,1.76,4.84,1,1.81-6.33,2.11-7.14,9.65-16.92,10.59-27.11S291.62,109.26,291.62,109.26Z",
    fill: "#ffc6b2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.75,102.74s-2.9,3.29-2.94,14.45c0,0,8.39,3.71,10.11,1.86L300,108.53",
    fill: "#68e1fd",
    className: "target-color"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M311.33,148.53s1.82,14.94,2.85,18.76,1.95,27.82,1.95,27.82,3.21,2.29,6,0c0,0,1.45-19.44.69-24.64s0-25.66,0-25.66",
    fill: "#ffc6b2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M300.81,144.22s-.36,11,0,14.65,1.94,26.64,1.94,26.64a4.09,4.09,0,0,0,5.33,0s1.76-11.38,1.55-13.56-.58-29.67-.58-29.67",
    fill: "#ffc6b2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M296.22,90.93c0,.06,17.73,2.8,16.73,8.59s-8.64,3.79-8.64,3.79L295.45,92.8",
    fill: "#f18f22"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M311.33,203.68a3.12,3.12,0,0,0,.6,3.46c1.53,1.63,3.54.82,5.24,0s6.49-5.09,5.83-6.22-.91-5.82-.91-5.82",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M316.05,193.25s-.77,4.43-1.87,5.86-3.7,5-2.85,5.87,1.47-1.82,2.85-1,.95,2.74,1.95,2.35,5.69-4.12,6.21-6.49-.65-6.54-.65-6.54",
    fill: "#68e1fd",
    className: "target-color"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M294.52,192s-.19,2.64,2.2,3.14,5.36-1,6.7-1.57,6.22-4.73,6.22-4.73l-.58-5.74",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M302.55,182.67s-1.43,3.55-4,4.89-4.59,3.92-4,4.4,1.82-1.24,2.49-.77.66,2.57,1.48,2,2.54.82,4.93-.81,1.63-2.3,3.64-3.06,2-6.32,2-6.32S304,184.19,302.55,182.67Z",
    fill: "#68e1fd",
    className: "target-color"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M300.36,124.2a40.56,40.56,0,0,0-2,11.09c-.37,6.67,2.34,45.72,2.34,45.72a20.85,20.85,0,0,0,12.45.66v8.92A18,18,0,0,0,327.48,188s-.89-59.26-13-70.83",
    fill: "#f15a24"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M311,120.87a21.38,21.38,0,0,0,3.43-3.7,82.84,82.84,0,0,0-4.64-9.83c-2.65-4.31-5.3-9.25-10.55-10.52a34.86,34.86,0,0,0-6,3.44,8.59,8.59,0,0,0-2.49,2.48c-.11,4.27.25,6.95,2.77,10.12s4.21,8.38,5.9,11.19C303.21,125,307.4,123.32,311,120.87Z",
    fill: "#68e1fd",
    className: "target-color"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M295.65,95.23,297.91,98s-1.22,2.62-3.6,2.94l-1.48-1.73",
    fill: "#ffb39c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M290.62,97.26c-4.35,3.62-6.47-.42-6.47-.42-6-7.46,3.54-11.5,3.54-11.5s7.39-2.69,8.62,7.86",
    fill: "#f18f22"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M283.15,93.45s6.76,9.59,10.5,6.48,1.32-6.3,1.32-6.3-3.42-6.5-7.53-5.46A5.86,5.86,0,0,0,283.15,93.45Z",
    fill: "#ffc6b2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M283.15,93.45s4.63,2,7.37-.19,5.13,2,5.13,2a6.39,6.39,0,0,0-.57-6.86c-1.44-2.13-6.75-3.72-9.44-1.72S281.21,91.89,283.15,93.45Z",
    fill: "#f18f22"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M310.05,138.07c-.06-.54-.91-.55-.85,0q2.38,22.44,3.76,45c0,.54.88.55.85,0Q312.44,160.51,310.05,138.07Z",
    fill: "#842e13"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M153.46,93.05a1.13,1.13,0,0,0-.09-.23,1.65,1.65,0,0,0,.65-1.27,1.16,1.16,0,0,0-.37-.84.86.86,0,0,0-.66-1.47c-1.26.12-2.24,1.65-3,2.54q-.85,1-1.61,2c0-1.07,0-2.16,0-3.17s-1.53-1.24-1.63-.17a15.28,15.28,0,0,1-1,4.71,1.54,1.54,0,0,0-.46.27A39.07,39.07,0,0,1,127.52,104a1.54,1.54,0,0,0-.14,3,1.51,1.51,0,0,0,.94,1.46,1.72,1.72,0,0,0,.69,1.22l-1.12.36c-1.82.55-1.36,3.52.49,3a43,43,0,0,0,18.36-11.06c.57-.44,1.13-.88,1.69-1.34.87-.72,5.07-4.13,4.3-5.86C153.13,94.2,153.66,93.82,153.46,93.05Z",
    fill: "#fbb5ad"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M129,72.55c-1.86.52-3.64,4.22-3.57,5.05L126.9,77l.28-.25A17,17,0,0,1,129,72.55Z",
    fill: "#fbb5ad"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M128.91,75.71a1,1,0,0,0-.29-.18l-.11-.12c-.64-.61-1.79,0-2.45.26a13.43,13.43,0,0,0-2.43,1.28c-.41.3-.59,1-.83,1.39-.33.61-.67,1.21-1,1.8a35.11,35.11,0,0,1-2.48,3.55,36,36,0,0,1-6,5.93c-1,.81.26,2.38,1.29,1.57l.74-.6a.87.87,0,0,0,1,.07,3.84,3.84,0,0,0,.51-.33l.24-.16a1,1,0,0,0,1.6.53l.76-.64a.9.9,0,0,0,.54-.41s0,1.39,0,1.35c1.23-1.05,2.86-4.13,4.16-5.93a.41.41,0,0,1,.09-.25c1-1.29,1-2.12,1.24-3.69a15,15,0,0,1,.53-2.69l1.95-1.2c.47-.29,1-.73,1-1.24A1,1,0,0,0,128.91,75.71Z",
    fill: "#fbb5ad"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M132.94,101.77c-6.59,1.21-7.61.38-10.63,0s-5.79-5-5.79-5,.23-9.56-6.19-2.74c-4.8,5.1-8.09,21-9.46,28.7,1.92,1.89,4.65,2.81,7.23,3.47a32.44,32.44,0,0,0,5.2,1,7.85,7.85,0,0,0,3.21-.36L121,113.19a21.67,21.67,0,0,0,14-2.46Z",
    fill: "#a0d700"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120.41,88.93s3.29,8.33-1,10.1-7.1-2.22-7.35-3.2S112.65,87.53,120.41,88.93Z",
    fill: "#fbb5ad"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M120.84,87.78a8.58,8.58,0,0,0-7-1.73,10.41,10.41,0,0,0-5.77,2.3,3.52,3.52,0,0,0-1.71-.79,3.66,3.66,0,0,0-3.88,1.88,3.17,3.17,0,0,0,.85,3.84,4,4,0,0,0,3,.59c0,.06,0,.12,0,.19,0,1.5-1.51,2.11-2.19,3.31a3,3,0,0,0-.41,1.83c.08.64.65,1.37.57,2a3,3,0,0,1-.8,1.25,6.62,6.62,0,0,0-.86,1.31c2.79,1.9,6.49,2.28,9.77,2a16.69,16.69,0,0,0,9.74-4,2.47,2.47,0,0,0-.53-.92A9.23,9.23,0,0,0,120,99.66c-.82-.6.24-2,.3-2.87.09-1.43-.88-2.12-2-2.73-.81-.44-.8-1-.71-1.83a3.28,3.28,0,0,1,.62-1.93,1.11,1.11,0,0,0,.75-.08,6.09,6.09,0,0,1,1.47-.47,1,1,0,0,0,.74-1.19A.83.83,0,0,0,120.84,87.78Z",
    fill: "#56403d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M117.39,90.6a16,16,0,0,0,4-1c0-.13.92-5-8-4.21s-5.86,11.66-5.86,11.66",
    fill: "#56403d"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5,198.2c-.77-.36-1.92-.7-2.41-1.47a4.71,4.71,0,0,1-.24-2.79q.1-1.33.27-2.65A.44.44,0,0,1,94,191a16,16,0,0,1,.24-2.15l-3.59-.73s-2.26,6-2.23,6.74,3,5.78,4.7,6.28,6.75-.52,7.22-1.14l0-.06C99.07,199.35,97.78,198.8,96.5,198.2Z",
    fill: "#fbb5ad"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M122.89,187.91c-1.17-.36-6.2-.08-6.2-.08s-.28-4.11-.16-4.3l-5.19-.18s-1.43,7.43-1.54,8.42c-.19,1.82,2,2.62,2.5,2.6a8.9,8.9,0,0,0,1.08-.32,15,15,0,0,1,0-2.87c.07-.43.19-.73.63-.85.79-.21,2.16.35,2.92.58s1.79.58,2.69.84c2.14-.86,4-1.71,4.15-2.11C124.24,188.66,124.69,188.46,122.89,187.91Z",
    fill: "#fbb5ad"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M124.58,188.41l-.11-.15c-.35-.42-1.39-.5-1.88-.56a24.45,24.45,0,0,0-5.91.14s4.74-.15,4.83.71a2.23,2.23,0,0,1-.68,1.88c-2.14,1.53-5-.7-6.79-1.72l-3.37-1.89-.53,2.85a21.42,21.42,0,0,0-.41,3.95c.2.43,2.18,1.75,2.64,1.57s1.93-.86,1.93-.86l.09-3.5s2.79,1.57,4.2,1.35C119.66,192,125.62,190.16,124.58,188.41Z",
    fill: "#56403d"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M91.77,195.25s1.27,6.12,1.92,6.58,8.17-1.1,7.23-2.6c-.6-1-5-1.41-5.37-1.56,0,0,2.23,1,2.19,1.37s-3.09,1.41-3.21,1.12-2.75-5.81-2.75-5.81L88.91,193l-3,5.19,2,1.11s.46,1.72.68,1.74a24.2,24.2,0,0,0,2.23-2.86,8.09,8.09,0,0,0,.49,2.24c.27.24,2.48,2.49,3.75,1.08l-1.8-2.5",
    fill: "#56403d"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M108.13,185.06c4.49,1.35,9.42,1.06,13.19-1.7.88-7.62,2.3-14.43,2.88-22.08.94-12.48.41-24.89-7.31-35.51l-15.65-4.1c-7.74,11.6-14.93,67.62-14.93,67.62s7.49,6,14,4.18l7.29-46.55s3.69,5.43,4.16,8.3C112.08,157.29,109,175.65,108.13,185.06Z",
    fill: "#f15a24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataArrangingIsometric);
export default __webpack_public_path__ + "static/media/data-arranging-isometric.7523398212c4f799698d7f24280e071d.svg";
export { ForwardRef as ReactComponent };